import type { ReactNode } from 'react';

interface PullQuoteProps {
  /** The quotation itself — one or more <p> elements (or plain text). */
  children: ReactNode;
  /** Who said it (rendered bold teal), e.g. "Court of Appeal". */
  source?: string;
  /** Where / when, e.g. "Hsin Chong". Follows the source after a middle dot. */
  context?: string;
}

/**
 * Editorial pull quote: centred italic serif between two gold hairlines with a
 * small gold diamond at the top. Styles live in
 * components/LongArticle/long-article.css (`figure.pull-quote`), which every
 * surface that hosts article prose already imports. Used by the `pull_quote`
 * slice and by the `> quote — Source · Context` rich-text shortcode in
 * app/[lang]/blog/components/CustomRichText.tsx.
 */
export default function PullQuote({ children, source, context }: PullQuoteProps) {
  const hasAttribution = Boolean(source || context);
  return (
    <figure className="pull-quote">
      <blockquote>{typeof children === 'string' ? <p>{children}</p> : children}</blockquote>
      {hasAttribution && (
        <figcaption>
          {source && <b>{source}</b>}
          {source && context && <span aria-hidden="true"> · </span>}
          {context}
        </figcaption>
      )}
    </figure>
  );
}
